import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { supabase } from "../SupabaseClient.tsx";
import "./ReceiptDetail.css";
import Order from "../types/Order.ts";
import EditReceiptForm from "../components/EditReceiptForm.tsx";
import ActionButton from "../components/ActionButton.tsx";
import { PiArrowLeft } from "react-icons/pi";

const ReceiptDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [order, setOrder] = useState<Order | null>(
    location.state?.order || null
  );
  const [receiptUrl, setReceiptUrl] = useState<string | null>(null);

  useEffect(() => {
    // If we don't have an order from props, fall back to fetching it
    if (!order && id) {
      const fetchOrder = async () => {
        const { data, error } = await supabase
          .from("orders")
          .select(
            "id, purchase_date, amount, status(name), origin(name), storage_path, name, notes, beneficiary, purchase_id, original_filename, created_at"
          )
          .eq("id", id)
          .single();

        if (error) {
          console.error("Error fetching order:", error);
        } else {
          setOrder(data);

          if (data.storage_path) {
            fetchReceiptUrl(data.storage_path);
          }
        }
      };

      fetchOrder();
    } else if (order?.storage_path) {
      // If we have an order but not the receipt URL, fetch it
      fetchReceiptUrl(order.storage_path);
    }
  }, [id, order]);

  const fetchReceiptUrl = async (storagePath: string) => {
    const { data, error } = await supabase.storage
      .from("order_receipts")
      .createSignedUrl(storagePath, 60);

    if (error) {
      console.error("Error fetching receipt URL:", error);
    } else {
      setReceiptUrl(data.signedUrl);
    }
  };

  const handleBack = () => {
    navigate("/receipt-library");
  };

  if (!order) {
    return <div>Loading...</div>;
  }

  return (
    <div className="global-page-screen">
      <div className="page">
        <div className="page-header">
          <div className="page-header-title">
            <h1>Receipt Detail</h1>
            <p>Let's manage and edit your receipt.</p>
          </div>
          <ActionButton
            icon={<PiArrowLeft />}
            text="Back to Library"
            onClick={handleBack}
            secondary={true}
          />
        </div>
        <EditReceiptForm
          order={order}
          receiptUrl={receiptUrl}
          fileName={order?.original_filename}
          detailView={true}
        />
      </div>
    </div>
  );
};

export default ReceiptDetail;
